import React, { Component } from 'react';
import { dateFromLocalToUTC, dateFromUTCToLocal } from '../../services/common-functions';
import DatePicker from 'react-date-picker';
import LabeledFormInput from '../labeled-form-input';
import PropTypes from 'prop-types';

class LabeledMonthPicker extends Component {

    handleDateChange = date => {

        this.props.onChange( dateFromLocalToUTC( date ) );

    }

    render () {

        const date = dateFromUTCToLocal( this.props.selected );
        return (
            <LabeledFormInput
                label={this.props.label}
            >
                <DatePicker
                    value={date}
                    onChange={this.handleDateChange}
                    name={this.props.name}
                    minDate={this.props.minDate}
                    maxDate={this.props.maxDate}
                    dateFormat={this.props.dateFormat}
                    maxDetail="year"
                    monthPlaceholder="MM"
                    yearPlaceholder="YYYY"
                    format={this.props.dateFormat}
                />
            </LabeledFormInput>
        );

    }

}
LabeledMonthPicker.displayName = 'LabeledMonthPicker';
LabeledMonthPicker.propTypes = {
    name: PropTypes.string.isRequired,
    selected: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    dateFormat: PropTypes.string.isRequired,
    minDate: PropTypes.string,
    maxDate: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};
export default LabeledMonthPicker;
